import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Swords, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ChallengeAccept() {
  const { code } = useParams();
  const [ch, setCh] = useState(null);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => { api.get(`/challenges/invite/${code}`).then((r) => { setCh(r.data); setAccepted(r.data.accepted); }).catch(() => setCh(false)); }, [code]);

  const accept = async () => {
    try { await api.post(`/challenges/invite/${code}/accept`); setAccepted(true); toast.success("Challenge accepted — book your slot!"); }
    catch (e) { toast.error(errMsg(e)); }
  };

  if (ch === false) return <div className="max-w-xl mx-auto px-5 py-24 text-center text-slate-400">Challenge not found.</div>;
  if (!ch) return <div className="max-w-xl mx-auto px-5 py-24 text-center text-slate-400">Loading…</div>;

  return (
    <div className="max-w-xl mx-auto px-5 py-20 text-center">
      <div className="h-16 w-16 rounded-full bg-violet-500/20 border border-violet-500/40 grid place-items-center mx-auto glow-violet">
        <Swords className="h-8 w-8 text-violet-300" />
      </div>
      <h1 className="font-display font-extrabold text-4xl mt-5">You've been challenged!</h1>
      <p className="text-slate-300 mt-3"><b className="text-violet-300">{ch.challenger_team}</b> dares your team to beat their escape time on <b>{ch.game?.name}</b>.</p>
      {ch.message && <p className="mt-4 italic text-slate-400">“{ch.message}”</p>}
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        {!accepted && <Button data-testid="accept-challenge" onClick={accept} className="bg-violet-600 hover:bg-violet-500">Accept challenge</Button>}
        <Link to={ch.game ? `/book/${ch.game.id}` : "/games"}>
          <Button data-testid="book-from-challenge" variant="secondary" className="w-full">Book your slot <ArrowRight className="h-4 w-4 ml-2" /></Button>
        </Link>
      </div>
      {accepted && <p className="mt-4 text-emerald-400 text-sm">Challenge accepted — good luck! 🔥</p>}
    </div>
  );
}
